// extracted by mini-css-extract-plugin
export var activityContainer = "_ja-0";
export var typingIndicatorContainer = "_ja-1";
export var typingIndicatorDot = "_ja-2";
export var wave = "_ja-3";